import { createToastErrorAdapter } from '@rentnerkev/toasts/errors'

export class AppError extends Error {
    readonly title: string
    readonly duration: number

    constructor(
        message: string,
        options?: {
            title?: string
            duration?: number
            cause?: unknown
        },
    ) {
        super(message, { cause: options?.cause })
        this.name = 'AppError'
        this.title = options?.title ?? 'Fehler'
        this.duration = options?.duration ?? 6000

        Object.setPrototypeOf(this, new.target.prototype)

        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, new.target)
        }
    }

    static getMessage(
        error: unknown,
        fallback: string = 'Ein unerwarteter Fehler ist aufgetreten.',
    ): string {
        return error instanceof Error && error.message
            ? error.message
            : fallback
    }
}

export const toastAppError = createToastErrorAdapter({
    normalize(error) {
        return error instanceof AppError
            ? {
                  content: error.message,
                  title: error.title,
                  duration: error.duration,
              }
            : { content: AppError.getMessage(error), title: 'Fehler' }
    },
})
